import NavBar from "../components/common/NavBar.js";
import Footer from "../components/common/Footer.js";
import Cards from "../components/layouts/Cards.js";
import AboutMe from "../components/layouts/AboutMe.js";
import MyWorks from "../components/layouts/MyWorks.js";
import ContactMe from "../components/layouts/ContactMe.js";

export default function Home() {
  return (
    <div>
      <NavBar />
      <Cards />
      <AboutMe />
      <MyWorks />
      <ContactMe />
      <Footer />
    </div>
  );
}
